export const opportunityReducerName = "opportunities";
